/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Split_DistanceInputs */

const en_ui_laps_split_distance = /** @type {(inputs: Ui_Laps_Split_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split distance`)
};

const de_ui_laps_split_distance = /** @type {(inputs: Ui_Laps_Split_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split-Distanz`)
};

/**
* | output |
* | --- |
* | "Split distance" |
*
* @param {Ui_Laps_Split_DistanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_split_distance = /** @type {((inputs?: Ui_Laps_Split_DistanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Split_DistanceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_split_distance(inputs)
	return de_ui_laps_split_distance(inputs)
});